import { render, staticRenderFns } from "./HomeBottomBar.vue?vue&type=template&id=7d54e6c4&scoped=true&"
import script from "./HomeBottomBar.vue?vue&type=script&lang=js&"
export * from "./HomeBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./HomeBottomBar.vue?vue&type=style&index=0&id=7d54e6c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54e6c4",
  null
  
)

export default component.exports